module.exports = __webpack_public_path__ + "static/img/login-bgc.7b54543b.jpg";